export const LOGOUT_RESPONSE_CODE = 'access_and_refresh_token_invalid'
